import { render, staticRenderFns } from "./ProtocoloEnvioDaRecepcao.vue?vue&type=template&id=730079e1&"
import script from "./ProtocoloEnvioDaRecepcao.vue?vue&type=script&lang=js&"
export * from "./ProtocoloEnvioDaRecepcao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports